import { applyMiddleware, compose, createStore as createReduxStore } from 'redux'
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import thunk from 'redux-thunk'
import reducers from './reducers';
import sagas from './sagas';
import createHistoryMiddleware from './middleware/history';

const createStore = (initialState = {}, history = createHistory()) => {
  // Saga
  const saga = createSagaMiddleware();
  const historyMiddleware = createHistoryMiddleware(history);

  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [saga, thunk, historyMiddleware];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];
  let composeEnhancers = compose;

  if (process.env.NODE_ENV === 'development') {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createReduxStore(
    reducers(),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
      ...enhancers
    )
  );
  store.asyncReducers = {};

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
  // store.unsubscribeHistory = browserHistory.listen(updateLocation(store))

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  store.runSaga = saga.run;
  store.runSaga(sagas);

  return store
};

export default createStore
